import React from "react";

const ActionItemsTable = ({ actionItems, isEditing, setActionItems }) => {


  const updateItem = (index, field, value) => {

    console.log("Updating item at index:", index, "Field:", field, "Value:", value);


    const updatedItems = [...actionItems];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value,
    };

    if (!updatedItems[index].isCompleted) {
      updatedItems[index].completeDate = null;
    }
    console.log(actionItems[index][field]);

    setActionItems(updatedItems);
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Problem Class</th>
            <th className="border p-2">Sub-Class</th>
            <th className="border p-2">Description</th>
            <th className="border p-2">Assigned To</th>
            <th className="border p-2">Schedule Date</th>

            <th className="border p-2">
              {isEditing ? "Completed" : "Status"}
            </th>
            {isEditing && <th className="border p-2">Complete Date</th>}
          </tr>
        </thead>
        <tbody>
          {actionItems.length > 0 ? (
            actionItems.map((item, index) => (
              <tr key={index} className="border-t">
                <td className="border p-2">{item.problemClass}</td>
                <td className="border p-2">{item.problemSubClass}</td>
                <td className="border p-2">{item.description || "N/A"}</td>
                <td className="border p-2">{item.assignedTo?.email || "Unassigned"}</td>
                <td className="border p-2">{item.scheduleDate ? item.scheduleDate.split("T").join(" | ") : "N/A"}</td>

                {isEditing ? (
                  <td className="border p-2">
                    <input
                      type="checkbox"
                      checked={item.isCompleted}
                      onChange={(e) => updateItem(index, "isCompleted", e.target.checked)}
                      className="cursor-pointer"
                    />
                  </td>
                ) : (
                  <td className="border p-2">{item.isCompleted ? "Completed" : "Pending"}</td>
                )}

                {isEditing && (
                  <td className="border p-2">
                    {item.isCompleted ? (
                      <input
                        type="datetime-local"
                        value={item.completeDate}
                        onChange={(e) => updateItem(index, "completeDate", e.target.value)}
                        onBlur={(e) => updateItem(index, "completeDate", e.target.value)}
                        className="border rounded p-1"
                        disabled={!item.isCompleted}
                        placeholder="Complete Date"
                      />
                    ) : (
                      <span className="text-gray-500">
                        Not Applicable
                      </span>
                    )}
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center p-4">No action items added.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div >
  );
};

export default ActionItemsTable;